import type {
  CarsEntryTrackingProperties,
  ViewedCarsListTrackingProperties,
  AppliedCarsFilterTrackingProperties,
  ViewedCarDetailsTrackingProperties,
} from "./types";

export enum CarCommonTrackingEventsName {
  modal_alert = "modal_alert",
}

export enum GroundShopTrackingEvents {
  // a customer views on car search
  viewed_cars_search = "viewed_cars_search",
  // a customer views on car search
  car_viewed_calendar = "car_viewed_calendar",
  // a customer performed a car search
  cars_entry = "cars_entry",
  // loading was shown to the user
  "viewed_car_availability_loading" = "viewed_car_availability_loading",
  // a customer views the cars list
  viewed_cars_list = "viewed_cars_list",
  // a customer applies a filter
  applied_cars_filter = "applied_cars_filter",
  // a customer selected a car on availability list
  "selected_car_from_list" = "selected_car_from_list",
  // loading was shown to the user
  "viewed_car_shop_loading" = "viewed_car_shop_loading",
  // add a driver for the booking
  add_traveler = "add_traveler",
  // select a driver for the booking
  select_travelers = "select_travelers",
  // a customer viewed car details in the shop page
  viewed_cars_details = "viewed_cars_details",
  // a customer reviewed the car details on checkout after adding their info
  reviewed_car_details_checkout = "reviewed_car_details_checkout",
  // a customer attempts to make a booking (fired after pollFinalized result)
  complete_buy_cars = "complete_buy_cars",
}

export const CAR_PRODUCT_TYPE = "car" as const;

export type CarHTSEventBasicProperties = {
  productType: typeof CAR_PRODUCT_TYPE;
};

export type CarHTSEventProperties<Properties> = CarHTSEventBasicProperties &
  Properties;

export const CarEventName = {
  ...CarCommonTrackingEventsName,
  ...GroundShopTrackingEvents,
};
export type CarEventName = typeof CarEventName;

export type ViewedCarSearch = {
  name: GroundShopTrackingEvents.viewed_cars_search;
  properties: Record<string, unknown>;
};

export type CarViewedCalendar = {
  name: GroundShopTrackingEvents.car_viewed_calendar;
  properties: Record<string, unknown>;
};

export type CarEntry = {
  name: GroundShopTrackingEvents.cars_entry;
  properties: CarsEntryTrackingProperties["properties"];
};

export type ViewedCarsListLoading = {
  name: GroundShopTrackingEvents.viewed_car_availability_loading;
  properties: {
    runTime: number;
  };
};

export type ViewedCarsList = {
  name: GroundShopTrackingEvents.viewed_cars_list;
  properties: CarsEntryTrackingProperties["properties"] &
    ViewedCarsListTrackingProperties["properties"];
};

export type AppliedCarsFilter = {
  name: GroundShopTrackingEvents.applied_cars_filter;
  properties: CarsEntryTrackingProperties["properties"] &
    ViewedCarsListTrackingProperties["properties"] &
    AppliedCarsFilterTrackingProperties["properties"];
};

export type ClickedCarOnCarsList = {
  name: GroundShopTrackingEvents.selected_car_from_list;
  properties: CarsEntryTrackingProperties["properties"] &
    ViewedCarsListTrackingProperties["properties"];
};

export type ViewedCarDetailsLoading = {
  name: GroundShopTrackingEvents.viewed_car_shop_loading;
  properties: {
    runTime: number;
  };
};

export type ViewedCarDetails = {
  name: GroundShopTrackingEvents.viewed_cars_details;
  properties: CarsEntryTrackingProperties["properties"] &
    ViewedCarsListTrackingProperties["properties"] &
    ViewedCarDetailsTrackingProperties["properties"];
};

export type CarHTSEvent =
  | ViewedCarSearch
  | CarViewedCalendar
  | CarEntry
  | ViewedCarsListLoading
  | ViewedCarsList
  | AppliedCarsFilter
  | ClickedCarOnCarsList
  | ViewedCarDetailsLoading
  | ViewedCarDetails;
